import { Icon } from './Icon';
import { cn } from '@/lib/utils';

interface PolicyLineProps {
  ok: boolean;
  label: string;
}

export function PolicyLine({ ok, label }: PolicyLineProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-1.5 text-[11.5px]',
        ok ? 'text-success' : 'text-muted',
      )}
    >
      <Icon name={ok ? 'check' : 'minus'} size={12} strokeWidth={2} />
      <span>{label}</span>
    </div>
  );
}
